import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { _preFormatDate } from '../../../../utils/validation';
import Ui from '../../../presentationals/Admin/Recovery/RAZORPAYData.component'
import Loader from '../../../presentationals/Loader/Loader.component'
import { getRazorpayData, getCashFreeReportDataFromDate } from '../../Admin/AdminActionCreator.component'
import { CheckFunction } from '../../../../layouts/MainTenantconfig';
import { FILTER_ACTION } from '../../../../reducers/CommonFilters.reducer';
import moment from 'moment';

class Razor extends React.Component {
    constructor(props) {
        super(props);
        const { customcommonFilters } = props;
        this.state = {
            Start: customcommonFilters.fromDate ? new Date(customcommonFilters.fromDate) : null,
            End: customcommonFilters.toDate ? new Date(customcommonFilters.toDate) : null,
            startDate: moment(customcommonFilters.fromDate).format('DD-MM-YYYY'),
            endDate: moment(customcommonFilters.toDate).format('DD-MM-YYYY'),
            loaderState: false,
            reporttype: "razorpay"
        }
    }

    componentDidUpdate(prevProps) {
        const { fromDate, toDate } = this.props.customcommonFilters;
        const { fromDate: prevFrom, toDate: prevTo } = prevProps.customcommonFilters;

        if (fromDate !== prevFrom || toDate !== prevTo) {
            const newStartDate = fromDate ? new Date(fromDate) : null;
            const newEndDate = toDate ? new Date(toDate) : null;

            if (
                newStartDate?.getTime() !== this.state.Start?.getTime() ||
                newEndDate?.getTime() !== this.state.End?.getTime()
            ) {
                this.setState({
                    Start: newStartDate,
                    End: newEndDate,
                    startDate: moment(fromDate).format('DD-MM-YYYY'),
                    endDate: moment(toDate).format('DD-MM-YYYY'),
                });
            }
        }
    }

    dateChangeHandler(e, type) {
        if (type === 'start') {
            this.setState({ startDate: _preFormatDate(e), Start: e })
            this.props.setCommonFilters({ fromDate: moment(e).format('YYYY-MM-DD') });
        }
        if (type === 'end') {
            this.setState({ endDate: _preFormatDate(e), End: e })
            this.props.setCommonFilters({ toDate: moment(e).format('YYYY-MM-DD') });
        }
        if (type === 'type') {
            this.setState({ reporttype: e.target.value })
        }
    }

    downloadreport() {
        if (this.state.reporttype == "razorpay") {
            this.setState({ loaderState: true })
            getRazorpayData(this.state.startDate, this.state.endDate, callBack => {
                if (callBack !== '') {
                    this.setState({ loaderState: false })
                }
            })
        } else if (this.state.reporttype == "cashfree") {
            this.setState({ loaderState: true })
            getCashFreeReportDataFromDate(this.state.startDate, this.state.endDate, callBack => {
                if (callBack !== '') {
                    this.setState({ loaderState: false })
                }
            })
        }
    }

    render() {
        const tenant = CheckFunction()
        return (
            <div>
                {this.state.loaderState ?
                    <Loader />
                    : ""}
                <Ui
                    downloadreport={this.downloadreport.bind(this)}
                    Start={this.state.Start}
                    End={this.state.End}
                    dateChangeHandler={this.dateChangeHandler.bind(this)}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    reporttype={this.state.reporttype}
                    tenant={tenant}
                />
            </div>
        )
    }
}

const mapStateToProps = ({ FilterReduce }) => {
    return {
        customcommonFilters: FilterReduce.commonFilters
    };
};

const mapDispatchToProps = dispatch => {
    return {
        ...bindActionCreators({}, dispatch),
        setCommonFilters: (payload) => dispatch({ type: FILTER_ACTION, payload })
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Razor);